<div class="time">
    <span class="hour">{{ timeString | date: 'HH' }}</span>
    <span class="dots" [class.visible]="dotsVisible" [class.hidden]="!dotsVisible">{{ dots }}</span>
    <span class="minutes">{{ timeString | date: 'mm' }}</span>
</div>
<div class="type">{{ timeType }}</div>